import { render, staticRenderFns } from "./platformCourseQuery.vue?vue&type=template&id=24296bea&scoped=true"
import script from "./platformCourseQuery.vue?vue&type=script&lang=js"
export * from "./platformCourseQuery.vue?vue&type=script&lang=js"
import style0 from "./platformCourseQuery.vue?vue&type=style&index=0&id=24296bea&prod&lang=less"
import style1 from "./platformCourseQuery.vue?vue&type=style&index=1&id=24296bea&prod&lang=less"
import style2 from "./platformCourseQuery.vue?vue&type=style&index=2&id=24296bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24296bea",
  null
  
)

export default component.exports